import type { FC, ReactNode } from "react";

import Page, { type PageProps } from "~/v2/components/Page";

type FundingLayoutProps = {
  title?: PageProps["title"];
  subtitle?: PageProps["subtitle"];
  className?: PageProps["className"];
  children: ReactNode;
  faq?: ReactNode;
};

export const Layout: FC<FundingLayoutProps> = ({
  title,
  subtitle,
  className,
  children,
  faq,
}) => {
  return (
    <Page title={title} subtitle={subtitle} className={className}>
      <div className="grid grid-cols-12 gap-8 pb-52 md:grid-cols-12 md:gap-4">
        <div className="col-start-1 col-end-12 md:col-start-1 md:col-end-7">
          {children}
        </div>
        <div className="col-start-1 col-end-12 md:col-start-8 md:col-end-13">
          {faq}
        </div>
      </div>
    </Page>
  );
};
